import { render, staticRenderFns } from "./TaskPaystubs.vue?vue&type=template&id=fc987a88&scoped=true"
import script from "./TaskPaystubs.vue?vue&type=script&lang=js"
export * from "./TaskPaystubs.vue?vue&type=script&lang=js"
import style0 from "./TaskPaystubs.vue?vue&type=style&index=0&id=fc987a88&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc987a88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc987a88')) {
      api.createRecord('fc987a88', component.options)
    } else {
      api.reload('fc987a88', component.options)
    }
    module.hot.accept("./TaskPaystubs.vue?vue&type=template&id=fc987a88&scoped=true", function () {
      api.rerender('fc987a88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Task/TaskElement/TaskPaystubs.vue"
export default component.exports